import styled from "@xstyled/styled-components";

const CircularImgWrapper = styled.div<{
  width?: string;
}>`
  width: ${({ width }) => (width ? width : "100%")};
  height: ${({ width }) => (width ? width : "100%")};
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  justify-content: center;
`;

const CircularImgInner = styled.img`
  display: inline;
  margin: 0 auto;
  width: 100%;
  object-fit: cover;
`;

interface CircularImgProps {
  src: string;
  alt: string;
  width?: string;
}

export function CircularImg({
  src,
  width,
  alt,
}: CircularImgProps): React.ReactElement {
  return (
    <CircularImgWrapper width={width}>
      <CircularImgInner src={src} alt={alt} />
    </CircularImgWrapper>
  );
}
